// This prevents "$RefreshSig$ is not defined" errors

if (typeof window !== 'undefined') {
  // @ts-expect-error - Polyfill for React Fast Refresh when it's disabled
  window.$RefreshReg$ = function () {
    // No-op
  }

  // @ts-expect-error - Polyfill for React Fast Refresh when it's disabled
  window.$RefreshSig$ = function () {
    return function (type: any) {
      return type
    }
  }
}

export {}
